var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V26C28 27.1046 27.1046 28 26 28H2C0.895431 28 0 27.1046 0 26V2Z",
    fill: "#E1F3EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8331 3.5H8.16646C6.88313 3.5 5.83313 4.55 5.83313 5.83333V24.5L13.9998 21L22.1665 24.5V5.83333C22.1665 4.55 21.1165 3.5 19.8331 3.5ZM19.8331 21L13.9998 18.4567L8.16646 21V7C8.16646 6.35833 8.69146 5.83333 9.33313 5.83333H18.6665C19.3081 5.83333 19.8331 6.35833 19.8331 7V21Z",
    fill: "#367C68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.e9eb98217847b3cf4a6280c366ab107f.svg";
export { ForwardRef as ReactComponent };